<template>
  <div class="profile-image text-center">
    <avatar-input v-model="avatar">
      <div slot="activator">
        <img v-lazy="'img/theme/user-default-grey.png'" class="rounded-circle" v-if="!avatar" title="trocar avatar">
        <img :src="avatar.imageURL" title="trocar avatar" class="rounded-circle" v-else>
      </div>
    </avatar-input>
    <div v-if="avatar && saved == false">
      <base-button size="sm" type="secondary" class="mt-2" @click="uploadImage" :disabled="this.saving"><i class="fa fa-camera"></i>&nbsp;salvar avatar</base-button>
    </div>                                                           
  </div>
</template>

<script>
import AvatarInput from './AvatarInput.vue'

export default {
  name: 'avatar',
  data () {
    return {
      avatar: {
        imageURL: ( !this.$store.state.auth.avatar ) ? null : this.$store.state.auth.avatar,
      },
      saving: false,
      saved: false
    }
  },
  components: {
    AvatarInput: AvatarInput
  },
  watch:{
    avatar: {
      handler: function() {
        this.saved = false
      },
      deep: true
    }
  },
  methods: {
    uploadImage() {
      this.saving = true
      this.$store.dispatch('auth/updateProfile', this.avatar.formData).then(response => {
        if ( response.perfil.avatar !== "" ) {
          let new_avatar = response.perfil.avatar;
          let objectUser = {
            'username': this.$store.state.auth.username,
            'first_name': this.$store.state.auth.first_name,
            'avatar': new_avatar
          };
          this.$store.dispatch('auth/setLoginData', objectUser);
        }
      });
      setTimeout(() => this.savedAvatar(), 1000)
    },
    savedAvatar() {
      this.saving = false
      this.saved = true
    }
  },
  created() {
    if ( this.avatar.imageURL !== null ) {
      this.saved = true
    }else {
      this.avatar = null
    }
  },
}
</script>
